const NzOrchardisedDetails = () => {
  return (
    <div className="pt-[20px] pb-[45px]">
      <div className="custom-container px-[30px] text-start mx-auto ">
        <div className="max-w-[1200px]  mx-auto">
          <div className="space-y-10">
            <div className="text-center ">
              <h3 className="text-[30px] kuunari-bold text-gray-800 mb-5 text-center ">
                For the full list of specifications- please see our eTuatara page.
              </h3>
              <div className="mt-7 text-[20px] leading-8 text-stone-500 max-md:max-w-full text-center ">
                ➢ Dimensions (L x W x H): 3580mm x 1550 mm x 1380 mm
                <br />➢ Cargo Deck :1600mm x 1400mm x 300mm
              </div>
              {/* <div>
                                <a
                                    href="#"
                                    className="px-5 py-5 mt-10 max-w-full text-base leading-3 text-white bg-yellow-600 w-[150px] max-md:pl-5"
                                >
                                    LEARN MORE
                                </a>
                            </div> */}
              <div className="flex justify-center align-items-center">
                <div
                  className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white leading-[40px] px-[16px] py-[5px] cursor-pointer mt-[50px]"
                  onClick={() => {}}
                >
                  LEARN MORE
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NzOrchardisedDetails;
